import * as React from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import { Link } from 'react-router-dom';
import {
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Button,
  FormFeedback,
} from 'reactstrap';
import * as Yup from 'yup';
import { useParams } from 'react-router';

const TeamForm = ({
  autoFocus = false,
  values,
  touched,
  errors,
  //    dirty,
  //    isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit,
  submitLabel = 'Create',
}) => {
  const { workspaceId } = useParams();

  const formikAttributes = (fieldName) => ({
    id: fieldName,
    name: fieldName,
    value: values[fieldName],
    onChange: handleChange,
    onBlur: handleBlur,
    invalid: errors[fieldName] && touched[fieldName],
  });

  const formikFeedback = (fieldName) => {
    return errors[fieldName] && touched[fieldName] ? (
      <FormFeedback>{errors[fieldName]}</FormFeedback>
    ) : null;
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col sm={4}>
          <FormGroup>
            <Label for="name">Name</Label>
            <Input
              type="text"
              {...formikAttributes('name')}
              autoFocus={autoFocus}
            />
            {formikFeedback('name')}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <Button type="submit" value="submit" color="primary">
            {submitLabel}
          </Button>
          <Link to={`/w/${workspaceId}/teams`} className="btn btn-secondary">
            Cancel
          </Link>
        </Col>
      </Row>
    </Form>
  );
};

const FormikTeamForm = withFormik({
  mapPropsToValues: ({ team = {} }) => {
    return {
      name: team.name || '',
    };
  },
  validationSchema: Yup.object().shape({
    name: Yup.string().required('Name is required!'),
  }),
  handleSubmit: (values, bag) => {
    const {
      setSubmitting,
      props: { onSave = () => {} },
    } = bag;
    setSubmitting(true);
    onSave(values);
  },
  displayName: 'TeamForm',
})(TeamForm);

FormikTeamForm.propTypes = {
  onSave: PropTypes.func,
  team: PropTypes.object,
  autoFocus: PropTypes.bool,
};

export default FormikTeamForm;
